// Polish

const lang = {
  gateMediaPreviewHeader: 'Może Cię również zainteresuje',
  loadmore: 'Pokaż więcej',
  nextMedia: 'Następny materiał',
  previousMedia: 'Poprzedni materiał',
  closePost: 'Zamknij wpis',
  nextPost: 'Następny wpis',
  previousPost: 'Poprzedni wpis',
  outOfStock: 'Niedostępny',
  numberOfReviews(n) {
    if (n % 10 === 1 && n % 100 !== 11) {
      return 'opinia'
    }
    return n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 'opinie' : 'opinii'
  },
  reportFormField: 'Proszę wpisać wiadomość',
  reportPost: 'Zgłoś treść',
  reportFormTitle: 'Czy chcesz zgłosić ten obraz?',
  reportFormDetails:
    'Jeśli uważasz, że obraz jest nieodpowiedni, nielegalny lub narusza czyjeś prawa, możesz to zgłosić. Jeśli zgłosisz obraz / tekst, moderatorzy treści zostaną o tym powiadomieni i zostaną podjęte odpowiednie działania.',
  reportFormMessagePlaceholder: 'Podaj powód zgłoszenia',
  reportFormMessageLabel: 'Wiadomość',
  reportFormEmailLabel: 'Twój e-mail',
  reportFormSubmitButtonText: 'Wyślij zgłoszenie',
  reportFormCancelButtonText: 'Anuluj',
  reportFormSentTitle: 'Dziękujemy za Twój raport!',
  reportFormSentCloseButtonText: 'Zamknij',
  cardAndTileAriaLabel:
    'Poniżej znajduje się lista wpisów z kont w różnych mediach społecznościowych',
  carouselAriaLabel:
    'Poniżej znajduje się karuzela wpisów z kont w różnych mediach społecznościowych',
  singleAriaLabel: 'Poniżej publikacja z konta w mediach społecznościowych',
  poweredBy: 'Technologia Flowbox',
  postAltText: (userName, date) => {
    const publishedString = date ? ` opublikowane w dniu ${date}` : ''
    const createdByString = userName ? ` użytkownika ${userName}` : ''
    return `Zdjęcie${createdByString}${publishedString}`
  },
  uploadYourMedia: 'Prześlij swoje multimedia',
  openTheGate: 'Otwórz okno dialogowe',
}

export default lang
